import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "../";
/**
* @class SavingsAccount
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.savingAccounts[0];
* const account = new SavingsAccount(record);
* @property {NUMBER} _mapID - The id to relate the saving account  
* @property {bcmsCurrency} _availableBalance - balance available in the account
* @property {STRING} _interestRate - the interest rate for the account
* @property {STRING} _ytdInterest - dollar amount of interest paid for year
* @property {bcmsCurrency} _currentBalance - The current balance of the account
*/
export default class SavingsAccount extends BCMSRecord{
    _mapID;   
    _availableBalance;  
    _interestRate;       
    _ytdInterest
    _ccurrentBalance;

    constructor (record){   
      super(Object.assign(record,Account.initByID(record.mapID).record))    
    }

    /** 
    * @function initAll   
    * @static
    * @property {VOID} - No parameters
    * @description Returns all accounts with branding option "Show Business Accounts" 
    * (action script name: show_business_accounts_abi22) applied.
    * @example const accounts = SavingsAccount.initAll();
    * @memberof SavingsAccount 
    */
       static initAll() {
        const { options } = this._GlobalController.state.branding;
        const showBusinessAccounts = options.show_business_accounts_abi22 === "true";
  
        const filterByBusinessValue = item => {
          if(showBusinessAccounts) {
            return true;
          } else {
            if(item.isBusiness === "true") {
              return false;
            }
          }
          return true;
        }
  
        const accounts = this._GlobalController.state[this._RecordType]
  
        return accounts.map((record) => {
            return Account.initByType(record.mapID);
        }).filter(filterByBusinessValue);
      }
  } 
  SavingsAccount.define({
    "recordType":"savingsAccounts",
    "recordIDProp":"mapID",
    "className" : "SavingsAccount",
    "recordProperties": [
      /** 
      * @name mapID
      * @instance
      * @property get {NUMBER} - gets the mapID of the account
      * @property set {NUMBER} - sets the mapID of the account
      * @memberof SavingsAccount 
      */
      BCMSRecordProperty.mapToNumber("mapID","_mapID"),
      /** 
      * @name availableBalance
      * @instance
      * @property get {bcmsCurrency} - gets the availableBalance of the account
      * @property set {bcmsCurrency} - sets the availableBalance of the account
      * @memberof SavingsAccount 
      */
      BCMSRecordProperty.mapToCurrency("availableBalance","_availableBalance"),
      /** 
      * @name interestRate
      * @instance
      * @property get {STRING} - gets the interestRate of the account
      * @property set {STRING} - sets the interestRate of the account
      * @memberof SavingsAccount 
      */
      BCMSRecordProperty.mapToString("interestRate","_interestRate"),
      /** 
      * @name ytdInterest
      * @instance
      * @property get {STRING} - gets the ytdInterest of the account
      * @property set {STRING} - sets the ytdInterest of the account
      * @memberof SavingsAccount 
      */
      BCMSRecordProperty.mapToString("ytdInterest","_ytdInterest"),

      /**
       * @name currentBalance
       * @instance
       * @property get {bcmsCurrency} - gets the currentBalance of the account
       * @property set {bcmsCurrency} - sets the currentBalance of the account
       * @memberof SavingsAccount
       */
      BCMSRecordProperty.mapToCurrency("currentBalance", "_currentBalance")
    ].concat(Account._RecordProperties)
})




